import { useMutation } from 'react-query'

import { logMessage } from '../../../../Logging/log'
import { uploadSlide } from '../api/upload'

const useStartUploadSlide = (liveId: number) => {
  return useMutation({
    mutationKey: ['uploadSlide', liveId],
    mutationFn: async (file: File) => {
      const data = await uploadSlide(liveId, file)
      return data.map((slide) => slide.url)
    },
    onError: (error) => {
      logMessage('Error uploading slide', {
        level: 'error',
        extra: { reason: error },
      })
    },
  })
}

export { useStartUploadSlide }
